<template>
  <div class="col-md-4 ml-auto mr-auto">
    <form @submit.prevent="forgot">
      <card class="card-login card-plain">

        <div slot="header">
          <div class="logo-container">
            <img src="/img/svg/login.svg" alt="login-logo" >
          </div>
        </div>

        <div>
          <p class="help-text">An email with reset link will be sent to your registered email. On clicking the link, your account password will be reset to your original default password.</p>
          <!-- change this back to email -->
          <fg-input v-model="model.email"
                    v-validate="'required'" 
                    name="email"
                    :error="getError('email')"
                    class="no-border form-control-lg"
                    placeholder="example@kristujayanti.com"
                    addon-left-icon="now-ui-icons ui-1_email-85">
          </fg-input>

        </div>

        <div slot="footer">
          <n-button native-type="submit" type="danger" round block>
            Reset Password
          </n-button>
          <!-- <div class="pull-left" >
            <h6>
              <router-link class="link footer-link" to="/register">
                Create Account
              </router-link>
            </h6>
          </div> -->
          <div class="text-center mt-2">
            <router-link tag="a" to="/auth/login" class="link footer-link">Back to Login</router-link>
          </div>
        </div>
      </card>
    </form>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      model: {
        email: '',
        password: ''
      }
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async forgot() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        let prefix = this.model.email.substr(0, this.model.email.indexOf('@'));
        let suffix = this.model.email.substr(this.model.email.indexOf('@'), this.model.email.length);
        let first2 = this.model.email.substr(0,2);

        if(Number.isInteger(Number(first2))){
          // email is a student registered email address
          this.model.email = prefix.toUpperCase()+suffix;
        }

        this.$store.dispatch('forgotPassword', this.model)
      }
    }
  }
};
</script>

<style scoped>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
p.help-text{
    color: #fff;
    text-align: center;
    font-size: 0.7rem;
    padding-top: 10px;
}
</style>
